// extracted by mini-css-extract-plugin
module.exports = {"container":"PolicyLoading_container__pdasK","text":"PolicyLoading_text__GE2MJ"};